<template>
  <div class="routerInfo">
    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <a  class="mainblock-label">文章详情</a>
          </div>
        </div>
        <div class="container-body panel-party">
          <div class="news-detail">
            <div class="news-detail-title" >{{detailData.newsTitle}}</div>
            <div class="news-detail-head" style="width: 100%;">
              <div style="text-align: right;flex: 1" class="detail-date"><span >{{detailData.pushDate | formatDate}}</span></div>
              <!--                         <div class="detail-record"><img class="list-icon" src="images/record.png" ><span id="viewCount"></span></div> -->
            </div>
            <div class="news-detail-content" v-html="detailData.newsContent">
            </div>
            <div class="news-detail-head" style="width: 100%;margin-top: 20px;margin-bottom: 5px">
              <div style="text-align: right;flex: 1" class="detail-date"><span >作者：{{detailData.author }}</span></div>
              <!--                         <div class="detail-record"><img class="list-icon" src="images/record.png" ><span id="viewCount"></span></div> -->
            </div>
            <div class="news-detail-head" style="width: 100%;display: flex;align-items: end">
              <div style="text-align: right;flex: 1" class="detail-date"><span >来源：{{detailData.source }}</span></div>
              <!--                         <div class="detail-record"><img class="list-icon" src="images/record.png" ><span id="viewCount"></span></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  import { mapState, mapGetters } from 'vuex'

  const moment = require('moment')
  export default {
    name: 'Training',
    inject:['findUserScore'],
    data(){
      return {
        newsList: [],
        newsId: '',
        detailData: {},
        startViewTime: null,

      }
    },
    filters: {
      formatDate (val) {
        if (val!==null){
          return moment(val).format('YYYY-MM-DD')
        }
        return ''
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      ...mapGetters({
        navigationList: 'navs'
      })
    },
    created() {
      this.newsId = this.$route.query.newsId
      this.findAllData()
      this.startViewTime = new Date()


    },
    methods:{
      findAllData(){
        let url = '/api/newsView/findNewsById'
        let that = this
        let params = {
          newsId: this.newsId
        }
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
          that.detailData = res.data
        }))


        setTimeout(()=>{
         that.addRecord()
        },60*1000)
      },

      addRecord(){
        let that = this
        let url = '/api/newsViewRecord/addNewsViewRecord'
        let params = {
          companyId: that.user.businessCompanyId,
          departmentId: that.user.departmentId,
          userId: that.user.userId,
          newsId: that.newsId,
          newsType: 1,
          startViewTime:that.startViewTime,
          endViewTime: new Date(),
          learnTime: 61
        }
        that.axios.post(url,params).then(res =>{
          that.findUserScore()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/NewsDetail.vue